import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { CartProvider } from './CartContext';
import Home from './Home';
// Re-enable alongside the routes below when checkout returns.
// import Cart from './Cart';
// import Checkout from './Checkout';
// import Confirmation from './Confirmation';

export default function App() {
  return (
    <CartProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/confirmation" element={<Confirmation />} /> */}

          {/* CloudFront rewrites any 404 to index.html, so an unknown path boots
              the app with no matching route and renders nothing. /cart and
              /checkout were public while checkout was live, so they must land
              somewhere real rather than on a blank screen. */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </CartProvider>
  );
}
